import React from 'react'

export default function PageNotFound() {
  return (
    <div className= ' relative mt-[200px] justify-center text-lg text-center'>PageNotFound</div>
  )
}
